import { Button, GlobalStyles, Grid, Link, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Acordion from "../components/Acordion";
import AddBeneficiaries from "../components/AddBeneficiares";
import AlertField from "../components/Alert";
import { ArrowButon } from "../components/ArrowButton";
import { DialogBox } from "../components/DialogBox";
import { Footer } from "../components/Footer";
import LeadInfo from "../components/LeadInfo";
import PlanInfo from "../components/PlanInfo";
import { PrimaryButton } from "../components/PrimaryButton";
import { AppContext } from "../context";
import { useWindowDimensions } from "../hooks/useWindowDimensions";
import backgroundWide from "../images/back-wide.jpg";

interface IDocuments {
  title: string;
  url: string;
}

export function ReviewPage() {
  const {
    logo,
    lead,
    updateEvent,
    updateLead,
    theme,
    plan,
    sendEmailValidation,
    showCardUser,
    beneficiaries,
    codeValidation,
    addBeneficiaries,
    documents,
    subAccountId,
  } = useContext<any>(AppContext);
  const history = useHistory();
  const [openDialog, setOpenDialog] = useState(false);
  const [checkbox, setCheckbox] = useState(true);
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const { width } = useWindowDimensions();
  const background = theme ? theme.palette.background.default : "#fff";
  const [addBeneficiariesDialogIsOpen, setAddBeneficiariesDialogIsOpen] =
    useState(false);

  useEffect(() => {
    console.log(lead);
    console.log(documents);
    updateEvent({ type: "SQL", leadId: lead.leadId });
    updateLead({ sql: true });
  }, []);

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  };

  const handleCheckbox = () => {
    setCheckbox(!checkbox);
  };

  const handleClose = () => {
    setOpenAlert(false);
  };

  const handleCloseAddBeneficiariesDialog = () => {
    setAddBeneficiariesDialogIsOpen(false);
  };

  const handleOpenAddBeneficiariesDialog = () => {
    setAddBeneficiariesDialogIsOpen(true);
  };

  const handleClick = async (e: any) => {
    e.preventDefault();
    const checkBox = checkbox;
    if (plan.validEmail || codeValidation) {
      await sendEmailValidation();
      history.push("/confirmacao");
    } else if (!checkBox) {
      setAlertMessage("É necessario aceitar os termos e condições");
      setOpenAlert(true);
    } else {
      await updateLead({ beneficiariesArray: beneficiaries });
      history.push("/pagamento");
    }
  };

  return (
    <Container component="main" maxWidth="lg">
      <GlobalStyles
        styles={{
          body: {
            backgroundColor: `${background}`,
          },
        }}
      />
      <Box sx={{ display: "flex", alignItems: "flex-end" }}>
        <AddBeneficiaries
          isOpen={addBeneficiariesDialogIsOpen}
          handleClose={handleCloseAddBeneficiariesDialog}
        />
        <AlertField
          message={alertMessage}
          status={openAlert}
          handle={handleClose}
        />
        {width > 400 && (
          <Box
            sx={{
              position: "absolute",
              top: 20,
              left: 0,
            }}
          >
            <ArrowButon path="/endereco" />
          </Box>
        )}
      </Box>
      <Paper
        variant="outlined"
        elevation={2}
        sx={{
          my: 3,
          backgroundColor: "background.default",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "space-evenly",
          p: 2,
          position: "relative",
          border: 0,
        }}
      >
        {width <= 400 && (
          <>
            <Box
              sx={{
                position: "absolute",
                top: 20,
                left: 0,
              }}
            >
              <ArrowButon path="/endereco" />
            </Box>
            <Box sx={{ m: "0 auto" }}>
              <img
                src={logo}
                alt=""
                style={{
                  margin: "0 auto",
                  width: "200px",
                }}
              />
            </Box>
          </>
        )}
        {width > 400 && (
          <Box sx={{ position: "relative", margin: "0 auto" }}>
            <img src={backgroundWide} alt="" style={{ margin: "0 auto" }} />
            <img
              src={logo}
              alt=""
              style={{
                margin: "0 auto",
                maxWidth: "200px",
                maxHeight: "60px",
                position: "absolute",
                left: "45%",
                top: "30%",
              }}
            />
          </Box>
        )}
        <Typography
          sx={{
            color: "primary.main",
            margin: "10px auto",
            fontSize: "3.5rem",
            fontWeight: "bold",
            fontFamily: 'Montserrat'
          }}
        >
          Quase lá!
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            color: "secondary.main",
            alignContent: "center",
            fontSize: "1.8rem",
            my: 2,
            fontFamily: 'Montserrat'
          }}
        >
          Vamos revisar e garantir que está tudo certo com a sua compra? <br />
        </Typography>
        <DialogBox status={openDialog} handle={handleDialog} />

        <Box sx={{ width: "100%", ml: -4 }}>
          <Grid
            container
            sx={{
              p: 0,
              mx: "auto",
              maxWidth: 800,
              width: "110%",
            }}
            rowSpacing={3}
            columnSpacing={4.5}
          >
            <Grid xs={12} sm={6} item>
              <PlanInfo />
            </Grid>
            {/* <Grid xs={12} sm={1.5} item>
               <Box />
              </Grid> */}
            <Grid xs={12} sm={6} item>
              <LeadInfo />
            </Grid>
          </Grid>
        </Box>
        {showCardUser && (
          <Box sx={{ mx: "auto", maxWidth: 900, width: "100%" }}>
            <Acordion />
          </Box>
        )}
        {/* <Typography sx={{
            textAlign: 'center',
            color: 'primary.main',
            alignContent: 'center',
            fontSize: '1.8rem',
            }} >
            Verifique sua Carteirinha Digital:
          </Typography>
          <CardUser /> */}

        {plan.validEmail || codeValidation ? (
          <>
            <Typography
              sx={{
                textAlign: "center",
                color: "primary.main",
                alignContent: "center",
                fontSize: "1.8rem",
                mt: 2,
                fontFamily: 'Montserrat'
              }}
            >
              Se estiver tudo certo, vamos prosseguir para a confirmação da
              compra! <br />
            </Typography>

            {documents && subAccountId !== "62a22cacd9e29a9f6de4d733" ? (
              <Typography
                sx={{
                  textAlign: "center",
                  color: "primary.main",
                  alignContent: "center",
                  fontSize: "1rem",
                }}
              >
                Verifique aqui
                {documents.map((document: IDocuments) => (
                  <Link target="_blank" href={document.url}>
                    {" "}
                    {document.title}
                  </Link>
                ))}
              </Typography>
            ) : documents && subAccountId === "62a22cacd9e29a9f6de4d733" ? (
              <Typography
                sx={{
                  textAlign: "center",
                  color: "primary.main",
                  alignContent: "center",
                  fontSize: "1rem",
                }}
              >
                {documents.map((document: IDocuments) => (
                  <Link target="_blank" href={document.url}>
                    {document.title}
                  </Link>
                ))}{" "}
                e verifique as condições gerais da cobertura do seu seguro, bem
                como, o regulamento dos serviços e benefícios.
              </Typography>
            ) : (
              <p></p>
            )}
            <Button
              sx={{ margin: "auto", my: 2, width: 150 }}
              variant="contained"
              color="primary"
              type="button"
              onClick={handleClick}
            >
              Prosseguir
            </Button>
          </>
        ) : (
          <>
            <Typography
              sx={{
                textAlign: "center",
                color: "secondary.main",
                alignContent: "center",
                fontSize: "1.8rem",
                mt: 2,
                fontFamily: 'Montserrat'
              }}
            >
              Se estiver tudo certo, vamos prosseguir para o pagamento! <br />
            </Typography>
            {addBeneficiaries && (
              <Typography
                sx={{
                  textAlign: "center",
                  color: "primary.main",
                  alignContent: "center",
                  fontSize: "1rem",
                  mt: 2,
                }}
              >
                os beneficiários serão os herdeiros legais previstos no código
                civil, ou
                <button
                  type="button"
                  onClick={handleOpenAddBeneficiariesDialog}
                  style={{
                    backgroundColor: "transparent",
                    border: "0",
                    color: "#656565",
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    sx={{ color: "#656565", textDecoration: "underline" }}
                  >
                    clique aqui
                  </Typography>
                </button>
                para informa-los... <br />
              </Typography>
            )}
            <form onSubmit={handleClick}>
              <Box
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  display: "flex",
                  mb: 1,
                }}
              >
                {/* <Checkbox 
          id='checkbox'
          value={checkbox}
          onChange={handleCheckbox}/>
          <Typography sx={{color: '#656565'}}>
            Li e Aceito a  
            <button 
              type="button"
              onClick={handleDialog}
              style={{
              backgroundColor: 'transparent', 
              border: '0',
              color: '#656565',
              cursor:'pointer'
              }}>
                <Typography sx={{color: '#656565', textDecoration:'underline'}}>
                Proposta
                </Typography>
                </button>
            {plan.plan_selected}
          </Typography> */}
              </Box>
              <Box sx={{ display: "flex", alignItems: "flex-end", my: 2 }}>
                <PrimaryButton name="Prosseguir" />
              </Box>
            </form>
          </>
        )}

        <Box sx={{ width: "100%", display: "flex" }}></Box>
        <Box sx={{ width: "100wv", alignItems: "center" }}>
          <Footer />
        </Box>
      </Paper>
    </Container>
  );
}
